module.exports = __webpack_public_path__ + "static/bg-down.285248f7.png";